import React, { useEffect, useState, useRef } from 'react';
import { numberFormatter } from '../../common/AgGrid/index.jsx';

import { Button } from '../../bootstrap/index.jsx';
import { FaIcon } from '../../common/Icons.jsx';
import useReordeableColumns from '../hooks/useColumnReorder.jsx';
import { Dialog, DialogHeader } from '../../bootstrap/index.jsx';
import { DialogFooter } from '../ColumnEdit.jsx';

const separatorStyle = {
  borderBottom: '1px solid var(--ag-border-color)', 
  height: 'var(--ag-header-height)',
  padding: '0 var(--ag-widget-container-horizontal-padding)',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex'
}


export const valueProps = {
  valueParser: params => Number(params.newValue),
  valueFormatter: numberFormatter
}

const newColumn = {
  ...valueProps,
  filter: 'agNumberColumnFilter', 
  cellEditor: 'agTextCellEditor',
  cellClass: 'align-right monospace',
  enableValue: true,
  editable: true,
  aggFunc: 'sum',
  pinned: null
}


// Only downcase chars
const createFieldAccessor = () => "   ".replaceAll(" ",()=>"abcdefghijklmnopqrstuvwxyz".charAt(Math.random()*26));

export default function ColumnConfigurationPanel({ api, columnApi, context }) {
  const [dialogColumn, setDialogColumn] = useState(null); // null => not visible, undefined => create, <index> => edit
  const isCreate = dialogColumn === undefined;
  const inputRef = useRef(null);

  const handleCreate = () => setDialogColumn(undefined);
  const handleEdit = (columnIndex) => setDialogColumn(columnIndex);
  const handleSave = (e, keepOpen) => {
    const columnDefs = api.getColumnDefs();
    if (isCreate) {
      columnDefs.push({...newColumn, headerName: inputRef.current.value, field: createFieldAccessor()})
    } else {
      columnDefs[dialogColumn].headerName = inputRef.current.value;
    }
    api.setGridOption('columnDefs', columnDefs);
    if (keepOpen){
      inputRef.current.focus();
    } else {
      handleClose();
    }
  }
  const handleClose = () => setDialogColumn(null);

  const handleDeleteCol = () => {
    console.log("handleDeleteCol")
  }
  const setColumns = (columnDefs) => {
    api.setGridOption('columnDefs', columnDefs);
  }

  const onReorder = () => {}

  const { columns, orderableColumns  } = useReordeableColumns(onReorder, handleEdit, api);
  const colDefs = api.getColumns().map((c) => c.colDef);
  const lastPinnedColumnIndex = colDefs.findLastIndex((c) => c.pinned);

  const EditDialog = ({ dialogColumn, defaultValue }) => {
    if (dialogColumn === null || !columns) return null;

    return (
      <Dialog 
        header={<DialogHeader onClose={handleClose} title='' showBorder={false} />} 
        footer={
          <DialogFooter 
            onClose={handleClose} 
            onSubmit={handleSave} 
            submitText={isCreate ? I18n.t('add') : I18n.t('save')} 
            handleDeleteCol={(e) => handleDeleteCol(e, values.id)} 
            deletable={true}
            isCreate={isCreate}
          />}
        size='xs'
        closeOnOutsideClick={false}
        onClose={handleClose}
      >
        <label>{I18n.t('name')}</label>
        <input 
          type='text' 
          ref={inputRef} 
          className='form-control' 
          defaultValue={columns[dialogColumn]?.cellRendererParams?.original?.name}
          onFocus={e => e.target.select()}
          autoFocus
        />
    </Dialog>
    );
  };

  return (
    <div>
      <div className='mb-1' style={separatorStyle}>
        <Button size='sm' className='full-width' onClick={handleCreate}>
          <FaIcon type='plus' className='mr-1'/>{I18n.t('add_column')}
        </Button>
      </div>
      {orderableColumns.slice(lastPinnedColumnIndex + 1)}
      <EditDialog dialogColumn={dialogColumn} />
      
    </div>
  );
};